
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M0 2h6v20H0z"}}),_c('path',{attrs:{"d":"M7 17l-2 2-2-2M7 7L5 5 3 7m2 7v3.566M5 10V6m6.25-3h9a1 1 0 011 1v2a1 1 0 01-1 1h-9a1 1 0 01-1-1V4a1 1 0 011-1zm0 7h9a1 1 0 011 1v2a1 1 0 01-1 1h-9a1 1 0 01-1-1v-2a1 1 0 011-1zm0 7h9a1 1 0 011 1v2a1 1 0 01-1 1h-9a1 1 0 01-1-1v-2a1 1 0 011-1z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    